import React from 'react'
import { SidebarContainer, Icon, CloseIcon } from './SidebarElements'
import { SidebarWrapper, SidebarMenu, SidebarLink } from './SidebarElements'


const Sidebar = ({isOpen, toggle}) => {
    return (
        <SidebarContainer isOpen = {isOpen} onClick={toggle}>
            <Icon onClick={toggle} >
                <CloseIcon />
            </Icon>
            <SidebarWrapper>
                <SidebarMenu>
                    <SidebarLink offset={-90} to="Comics" onClick={toggle}>
                        THE COMIC
                    </SidebarLink>
                    <SidebarLink offset={-90} to="Intro" onClick={toggle}>
                        INTRO
                    </SidebarLink>
                    <SidebarLink offset={-90} to="Roadmap" onClick={toggle}>
                        ROADMAP
                    </SidebarLink>
                    <SidebarLink offset={-90} to="Mint" onClick={toggle}>
                        MINT
                    </SidebarLink>
                    <SidebarLink offset={-90} to="FAQs" onClick={toggle}>
                        FAQS
                    </SidebarLink>
                    <SidebarLink offset={-90} to="Team" onClick={toggle}>
                        TEAM
                    </SidebarLink>  
                    <SidebarLink to="Contact" onClick={toggle}>
                        COMMUNITY
                    </SidebarLink>  
                </SidebarMenu>
                
            </SidebarWrapper>
        </SidebarContainer>)
}

export default Sidebar
